<template>
  <div class="flex flex-col w-full gap-2">
    <div class="flex items-center gap-4 pt-4 w-full">
      <Avatar
        :label="getTwoChars(customer?.fullName)"
        shape="circle"
        size="large"
        class="flex-none"
        :style="{ backgroundColor: markerColorKey === 'white' ? 'none' : markerColorValue }"
      />
      <div class="flex flex-col flex-grow">
        <div class="flex items-center gap-2">
          <span class="text-xl font-medium">{{ customer?.fullName }}</span>
          <span v-if="tags.length > 0" class="mx-1">○</span>
          <div v-if="tags.length > 0" class="flex flex-nowrap overflow-x-scroll gap-2">
            <Badge
              v-for="tag of tags"
              :key="tag"
              :value="tag"
              severity="contrast"
              class="flex-none"
            />
          </div>
        </div>
        <span
          v-if="subTitle"
          class="text-sm text-gray-500">
          {{ subTitle }}
        </span>
      </div>
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { getTwoChars } from '@torim-app/utils';
import { computed, onMounted, PropType, ref } from 'vue';
import { CUSTOMER_MARKER_COLOR_DEFAULT, CUSTOMER_MARKER_COLORS, ICustomer } from '@torim-app/types';
import { useToast } from 'vue-toastification';
import { useAdminClientsStore } from '@app/stores';
import { CustomersApi } from '@app/api/admin';

const toast = useToast();
const adminClientsStore = useAdminClientsStore();

const props = defineProps({
  customer: {
    type: Object as PropType<ICustomer>,
    required: true
  },
  subTitle: {
    type: String,
    required: false,
    default: ''
  }
});

const tags = ref<string[]>([]);
const markerColorKey = computed(() => props.customer?.markerColor || CUSTOMER_MARKER_COLOR_DEFAULT);
const markerColorValue = computed(() => CUSTOMER_MARKER_COLORS.find(c => c.key === markerColorKey.value)?.value ?? '#FFFFFF');

onMounted(() => {
  CustomersApi.fetchTagsAndSuggestions(props.customer.id).then(result => {
    tags.value = result.tags;
  });
});
</script>

